module.exports = __webpack_public_path__ + "static/media/pink.06df8aee.png";